// Varsayılan dashboard konfigürasyonu
// Bu yapı backend'e kaydedilip yüklenebilir
// rowHeight=80 ile hesaplanmış h değerleri

export const defaultDashboard = {
  dashboardId: "main_dashboard",
  name: "Ana Sayfa",
  widgets: [
    // Status Cards Row (h=1 → 80px)
    {
      id: "status-edge",
      type: "statuscard",
      position: { x: 0, y: 0, w: 2, h: 1 },
      config: {
        title: "Edge ID",
        metric: "edgeId",
        value: "edge-001",
        color: "blue",
      },
    },
    {
      id: "status-dataflow",
      type: "statuscard",
      position: { x: 2, y: 0, w: 2, h: 1 },
      config: {
        title: "Data Flow",
        value: "OK",
        color: "green",
      },
    },
    {
      id: "status-sync",
      type: "statuscard",
      position: { x: 4, y: 0, w: 2, h: 1 },
      config: {
        title: "Cloud Sync",
        value: "SYNCING",
        color: "orange",
      },
    },
    {
      id: "status-alarms",
      type: "statuscard",
      position: { x: 6, y: 0, w: 2, h: 1 },
      config: {
        title: "Alarms Active",
        value: "1",
        color: "orange",
        icon: "⚠️",
      },
    },
    {
      id: "status-anomaly",
      type: "statuscard",
      position: { x: 8, y: 0, w: 2, h: 1 },
      config: {
        title: "Anomalies",
        value: "3",
        color: "yellow",
      },
    },
    {
      id: "status-cpu",
      type: "statuscard",
      position: { x: 10, y: 0, w: 2, h: 1 },
      config: {
        title: "CPU",
        metric: "cpu",
        unit: "%",
        color: "green",
      },
    },

    // Gauge Row (h=1 → 80px)
    {
      id: "gauge-temp",
      type: "gauge",
      position: { x: 0, y: 1, w: 2, h: 1 },
      config: {
        title: "Temperature",
        metric: "temperature",
        unit: "°C",
        min: 0,
        max: 100,
        thresholds: { warning: 60, danger: 80 },
      },
    },
    {
      id: "gauge-vibration",
      type: "gauge",
      position: { x: 2, y: 1, w: 2, h: 1 },
      config: {
        title: "Vibration",
        metric: "vibration",
        unit: "mm/s",
        min: 0,
        max: 100,
        thresholds: { warning: 50, danger: 75 },
      },
    },
    {
      id: "gauge-pressure",
      type: "gauge",
      position: { x: 4, y: 1, w: 2, h: 1 },
      config: {
        title: "Pressure",
        metric: "pressure",
        unit: "kPa",
        min: 60,
        max: 150,
        thresholds: { warning: 80, danger: 90 },
      },
    },
    {
      id: "gauge-voltage",
      type: "gauge",
      position: { x: 6, y: 1, w: 2, h: 1 },
      config: {
        title: "Voltage",
        metric: "voltage",
        unit: "V",
        min: 180,
        max: 260,
        thresholds: { warning: 85, danger: 95 },
      },
    },
    {
      id: "gauge-current",
      type: "gauge",
      position: { x: 8, y: 1, w: 2, h: 1 },
      config: {
        title: "Current",
        metric: "current",
        unit: "A",
        min: 0,
        max: 30,
        thresholds: { warning: 70, danger: 90 },
      },
    },

    // Charts Row (h=3 → ~244px)
    {
      id: "chart-temp",
      type: "linechart",
      position: { x: 0, y: 2, w: 6, h: 2 },
      config: {
        title: "Temperature Trend",
        metric: "temperature",
        unit: "°C",
        color: "#ff9800",
      },
    },
    {
      id: "chart-vibration",
      type: "linechart",
      position: { x: 6, y: 2, w: 6, h: 2 },
      config: {
        title: "Vibration Trend",
        metric: "vibration",
        unit: "mm/s",
        color: "#4caf50",
      },
    },

    // Table (h=2 → ~162px)
    {
      id: "table-recent",
      type: "table",
      position: { x: 0, y: 5, w: 6, h: 2 },
      config: {
        title: "Recent Events",
      },
    },

    // Alarm & Anomali Bar Chart (h=2 → ~162px)
    {
      id: "bar-alarm-anomaly",
      type: "barchart",
      position: { x: 6, y: 5, w: 6, h: 2 },
      config: {
        title: "Alarm & Anomali",
        labels: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"],
        datasets: [
          { label: "Alarm", data: [3, 1, 4, 2, 0, 1, 2], color: "#f85149" },
          { label: "Anomali", data: [5, 3, 7, 4, 2, 3, 6], color: "#ff9800" },
        ],
      },
    },
  ],
};

// Widget tipleri listesi (ekleme menüsü için)
export const widgetTypes = [
  {
    type: "statuscard",
    label: "Status Card",
    icon: "📊",
    defaultSize: { w: 2, h: 1 },
  },
  {
    type: "gauge",
    label: "Gauge",
    icon: "⏱️",
    defaultSize: { w: 2, h: 1 },
  },
  {
    type: "linechart",
    label: "Line Chart",
    icon: "📈",
    defaultSize: { w: 6, h: 3 },
  },
  {
    type: "barchart",
    label: "Bar Chart",
    icon: "📊",
    defaultSize: { w: 4, h: 3 },
  },
  {
    type: "table",
    label: "Table",
    icon: "📋",
    defaultSize: { w: 6, h: 3 },
  },
  {
    type: "edge_logs",
    label: "Edge Logs",
    icon: "🖥️",
    defaultSize: { w: 12, h: 5 },
  },
];

// Metrik listesi
export const availableMetrics = [
  { key: "temperature", label: "Temperature", unit: "°C" },
  { key: "vibration", label: "Vibration", unit: "mm/s" },
  { key: "pressure", label: "Pressure", unit: "kPa" },
  { key: "voltage", label: "Voltage", unit: "V" },
  { key: "current", label: "Current", unit: "A" },
  { key: "cpu", label: "CPU Usage", unit: "%" },
  { key: "ram", label: "RAM Usage", unit: "%" },
  { key: "disk", label: "Disk Usage", unit: "%" },
];
